export function destinosEquivalentes(comparacao, origemId, principalId, mapas = {}) {
    const ids = comparacao?.equivalenciasVinculos?.find((v) => Number(v.produtoEmbalagemOrigemId) === Number(origemId))?.destinosEquivalentesIds || [];
    return (comparacao?.apresentacoes || []).filter((v) => ids.includes(Number(v.id)) &&
        (Number(v.produtoId) === Number(principalId) || mapas[v.id]?.acao === 'PRESERVAR_VINCULO'));
}

// Só sugere equivalência depois da escolha manual do produto principal.
// Destinos ambíguos continuam exigindo escolha; a prévia nunca grava dados.
export function sugerirMapas(comparacao, principalId) {
    const mapas = {};
    for (const v of comparacao?.apresentacoes || []) {
        if (Number(v.produtoId) === Number(principalId)) continue;
        const destinos = destinosEquivalentes(comparacao, v.id, principalId);
        mapas[v.id] = destinos.length === 1
            ? { acao: 'ASSOCIAR_EQUIVALENTE', produtoEmbalagemDestinoId: Number(destinos[0].id) }
            : { acao: 'PRESERVAR_VINCULO' };
    }
    return mapas;
}
